export const logoutFailureMessage = "Sign-out could not be confirmed. Please retry before leaving this device.";

export async function requestLogout(kind: "customer" | "staff", fetcher: typeof fetch = fetch) {
  try {
    const response = await fetcher(kind === "customer" ? "/api/customer/logout" : "/api/admin/staff/logout", {
      method: "POST",
      credentials: "same-origin",
      redirect: "error",
      headers: { "Content-Type": "application/json" },
      signal: AbortSignal.timeout(15_000),
    });
    if (!response.ok || (await response.json()).ok !== true) throw new Error("Unconfirmed logout");
  } catch {
    throw new Error(logoutFailureMessage);
  }
}
